import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { ScopeOfWorkData } from "@rebuild/shared";
import { EditableText } from "../../EditableText";
import type { PDFPreviewFormData } from "../pdfPreview.types";
import { PDFCategoryGroupedEditor } from "./PDFCategoryGroupedEditor";
import { PDFRoomGroupedEditor } from "./PDFRoomGroupedEditor";
import type { useInlineEditing } from "../hooks/useInlineEditing";

type InlineEditingReturn = ReturnType<typeof useInlineEditing>;

interface PDFScopeOfWorkEditorProps {
  control: Control<PDFPreviewFormData>;
  editableScopeOfWork: ScopeOfWorkData | null;
  inlineEditing: InlineEditingReturn;
  includeQuantity: boolean;
}

export function PDFScopeOfWorkEditor({ control, editableScopeOfWork, inlineEditing, includeQuantity }: PDFScopeOfWorkEditorProps) {
  const isRoomGrouped = editableScopeOfWork?.type === "room-grouped";

  return (
    <div className="mb-8">
      {/* Editable Scope of Work Title */}
      <Controller
        name="scopeOfWorkTitle"
        control={control}
        render={({ field: { onChange, value } }) => (
          <EditableText
            value={value}
            onChange={onChange}
            displayAs="h2"
            displayClassName="font-bold text-sm mb-2"
            editClassName="font-bold text-sm mb-2 w-full"
          />
        )}
      />
      {/* Editable Organization Name in intro text */}
      <Controller
        name="organizationName"
        control={control}
        render={({ field: { onChange, value } }) => (
          <p className="mb-4 text-sm">
            <EditableText value={value} onChange={onChange} suffix=" proposes to perform the following repairs:" />
          </p>
        )}
      />

      {isRoomGrouped && editableScopeOfWork ? (
        <PDFRoomGroupedEditor
          editableScopeOfWork={editableScopeOfWork as ScopeOfWorkData & { type: "room-grouped" }}
          inlineEditing={inlineEditing}
          includeQuantity={includeQuantity}
        />
      ) : (
        <PDFCategoryGroupedEditor control={control} />
      )}
    </div>
  );
}
